import { Component, Input } from '@angular/core';
import { INpsSummary } from '../../models/nps-summary.model';

/** Bloque "Detractor / Pasivo / Promotor" con o sin mini barras. */
@Component({
  selector: 'app-nps-breakdown',
  templateUrl: './nps-breakdown.component.html',
  styleUrl: './nps-breakdown.component.scss',
  standalone: false,
})
export class NpsBreakdownComponent {
  @Input({ required: true }) public summary!: INpsSummary;
  /** true = muestra la mini barra de progreso bajo cada valor (dashboard). */
  @Input() public withBars = false;
}
